import {Component} from 'react'
import {Field, reduxForm} from 'redux-form'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import Aperture from 'react-feather/dist/icons/aperture.js'
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import FonctionTypeahead from '../../../../shared/components/Form/Field/FonctionTypeahead.jsx'
import ExpertiseTypeahead from '../../Form/Field/ExpertiseTypeahead.jsx'
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'
import validate from './validate.js'

import './SkillsForm.scss'

export const name = 'GeneralPresForm'

class SkillsForm extends Component {
  static propTypes = {
    counter: PropTypes.number,
    enrichMasterSkills: PropTypes.func,
    enrichingMasterSkills: PropTypes.bool,
  }

  static defaultProps = {
    counter: 1300,
    enrichMasterSkills: null,
    enrichingMasterSkills: false,
  }

  constructor(props) {
    super(props)
  }

  limiter = (value) => {
    if(value.length > this.props.counter) {
      return value.substring(0, this.props.counter)
    }

    return value
  }

  render() {
    return (
      <div id={name}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <h2 className="text-center mb-4">Compétences</h2>
          {this.props.enrichMasterSkills &&
            <div className="text-center mb-4">
              <button
                type="button"
                className={`btn btn-secondary btn-sm ${this.props.enrichingMasterSkills ? 'btn-loading' : ''}`}
                style={this.props.enrichingMasterSkills ? {opacity: 0.7} : undefined}
                disabled={this.props.enrichingMasterSkills}
                onClick={this.props.enrichMasterSkills}
              >
                {this.props.enrichingMasterSkills
                  ? <svg style={{width: 14, height: 14, animation: 'loader-rotate 1s linear infinite', marginRight: 6, marginBottom: 3, verticalAlign: 'middle', flexShrink: 0}} viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeDasharray="50 150" /></svg>
                  : <Aperture size={14} style={{marginRight: 6}} />
                }
                Enrichir les compétences
              </button>
            </div>
          }

          {this.props.isAdmin &&
            <>
              <div className="row">
                <div className="col-lg-6">
                  <Field
                    label="Compétences - Mes spécialités (8 max)"
                    name="freelance.master_skills"
                    placeholder={this.props?.currentUniverse?.master_skills_placeholder ?? ''}
                    component={ExpertiseTypeahead}
                    customOnChange={() => this.props.submit()}
                    disabled={this.props.enrichingMasterSkills}
                  />
                </div>
                <div className="col-lg-6">
                  <Field
                    label="Compétences - Niveau Confirmé (10 max)"
                    name="freelance.expertises"
                    placeholder={this.props?.currentUniverse?.expertises_placeholder ?? ''}
                    component={ExpertiseTypeahead}
                    customOnChange={() => this.props.submit()}
                    disabled={this.props.enrichingMasterSkills}
                  />
                </div>
              </div>
            </>
          }

          <h2 className="text-center mt-5 mb-4">Fonctions</h2>
          <div className="row">
            <div className="col-lg-12">
              <Field
                label="Métiers/Fonctions exercées"
                name="freelance.fonctions"
                placeholder={this.props?.currentUniverse?.fonctions_placeholder ?? ''}
                component={FonctionTypeahead}
                customOnChange={() => this.props.submit()}
                disabled={this.props.enrichingMasterSkills}
              />
            </div>
          </div>
          <input className="d-none" type="submit"/>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit} contains={true}/>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    currentUniverse: state.universe.currentUniverse,
  })
)(reduxForm({
  form: name,
  validate,
  onSubmitFail: createOnSubmitFailHandler(name)
})(SkillsForm))
